<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Diğer Zimmet Kalemleri</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="openCreate">
        <v-icon left>add</v-icon>
        Yeni Kalem
      </v-btn>
    </v-toolbar>

    <div class="caption grey--text px-3 pb-2">
      Pirinç çerçeve, gümüş zincir gibi adet bazlı kalemler. Envantere "Diğer Ekle" ile bu kalemlerden seçilerek girilir; ürün reçetelerinde (Envanter Kalemleri) kullanılır.
    </div>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :rows-per-page-items="[50, 100, { text: 'Tümü', value: -1 }]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-2">{{ props.item.name }}</td>
        <td class="px-2 text-xs-right">{{ formatHas(props.item.hasKarsiligi) }}</td>
        <td class="px-2">
          <v-chip small :color="props.item.isActive ? 'green' : 'grey'" text-color="white">
            {{ props.item.isActive ? 'Aktif' : 'Pasif' }}
          </v-chip>
        </td>
        <td class="px-2">
          <v-icon small class="mr-2" color="blue" @click="openEdit(props.item)">edit</v-icon>
          <v-icon small color="red" @click="remove(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center pa-4 grey--text">Henüz diğer kalem tanımlanmadı.</div>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="460" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          {{ editing ? 'Kalem Düzenle' : 'Yeni Diğer Kalem' }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-text-field v-model="form.name" label="Kalem Adı" placeholder="Örn. Pirinç Çerçeve, Gümüş Zincir" autofocus></v-text-field>
          <v-text-field
            v-model="form.hasKarsiligi"
            label="Has Karşılığı (adet başı gram-has)"
            placeholder="Örn. 0,12"
            hint="Envantere eklenince adet × bu değer Toplam Has'a girer. Yoksa 0 bırakın."
            persistent-hint
          ></v-text-field>
          <v-switch v-model="form.isActive" :label="form.isActive ? 'Aktif' : 'Pasif'" color="green"></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="saving" @click="save">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    saving: false,
    items: [],
    dialog: false,
    editing: false,
    form: { id: null, name: "", isActive: true, hasKarsiligi: "" },
    headers: [
      { text: "Kalem Adı", value: "name" },
      { text: "Has Karşılığı", value: "hasKarsiligi", align: "right" },
      { text: "Durum", value: "isActive" },
      { text: "", value: "actions", sortable: false },
    ],
  }),

  created() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      try {
        this.items = (await this.$store.dispatch("inventory/getOtherItems")) || [];
      } catch (e) {
        this.notify("Kalemler yüklenemedi: " + this.errMsg(e));
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editing = false;
      this.form = { id: null, name: "", isActive: true, hasKarsiligi: "" };
      this.dialog = true;
    },
    openEdit(item) {
      this.editing = true;
      this.form = {
        id: item.id,
        name: item.name,
        isActive: item.isActive,
        hasKarsiligi: item.hasKarsiligi ? String(item.hasKarsiligi).replace(".", ",") : "",
      };
      this.dialog = true;
    },
    async save() {
      if (!this.form.name || !this.form.name.trim()) { this.notify("Kalem adı girin."); return; }
      this.saving = true;
      try {
        const dto = { name: this.form.name, isActive: this.form.isActive, hasKarsiligi: this.parseHas(this.form.hasKarsiligi) };
        if (this.editing) {
          await this.$store.dispatch("inventory/updateOtherItem", { id: this.form.id, dto });
        } else {
          await this.$store.dispatch("inventory/createOtherItem", dto);
        }
        this.dialog = false;
        await this.load();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.saving = false;
      }
    },
    async remove(item) {
      if (!confirm(`'${item.name}' silinsin mi?`)) return;
      try {
        await this.$store.dispatch("inventory/deleteOtherItem", item.id);
        await this.load();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      }
    },
    parseHas(s) {
      if (s == null || s === "") return 0;
      const n = parseFloat(String(s).trim().replace(",", "."));
      return Number.isNaN(n) || n < 0 ? 0 : n;
    },
    formatHas(v) {
      if (v == null || Number(v) === 0) return "—";
      return Number(v).toLocaleString("tr-TR", { maximumFractionDigits: 4 });
    },
    errMsg(e) {
      return (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || "Bilinmeyen hata";
    },
    notify(msg) {
      this.$store.state.dialog = true;
      this.$store.state.message = msg;
    },
  },
};
</script>
